import { Button, Input, Space, Typography } from 'antd'
import { useState } from 'react'
import { useWriteHeapSnapshotMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import CIMSLink from 'components/CIMSLink'
import AnchorButton from 'components/AnchorButton'
import { REACT_APP_BACK_END_URL } from 'config'

const Snapshots: React.FC = () => {
  const [writing, setWriting] = useState(false)
  const [write] = useWriteHeapSnapshotMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({ writeHeapSnapshot: { id } }) => setId(id),
  })
  const [id, setId] = useState<string>()
  return (
    <Space size="large" direction="vertical">
      <Typography.Text>
        Enter the snapshot name or use the Write Heap Snapshot mutation to
        create a new snapshot, automatically filling the name on completion.
      </Typography.Text>
      <Typography.Text>
        Then use the Download Heap Snapshot API Request to download the snapshot
      </Typography.Text>
      <Typography.Text>
        While not a comprehensive guide, this{' '}
        <CIMSLink
          external
          href="https://nodejs.org/en/learn/diagnostics/memory/using-heap-snapshot/#how-to-find-a-memory-leak-with-heap-snapshots"
        >
          guide
        </CIMSLink>{' '}
        from NodeJS' learning site is a decent starting point
      </Typography.Text>
      <Space>
        <Button
          loading={writing}
          disabled={writing || !!id}
          onClick={async () => {
            setWriting(true)
            await write()
            setWriting(false)
          }}
        >
          Write Heap Snapshot
        </Button>
        <Input
          style={{ minWidth: 500 }}
          disabled={writing}
          value={id}
          onChange={({ target }) => setId(target.value)}
          allowClear
        />
      </Space>
      <AnchorButton
        disabled={!id || !id.length}
        loading={writing}
        href={`${REACT_APP_BACK_END_URL}/api/snapshots/${id}`}
        onClick={() => setId(undefined)}
      >
        Download Heap Snapshot
      </AnchorButton>
    </Space>
  )
}

export default Snapshots
